import TournamentsPage from './TournamentsPage';
import RegisteredTournaments from './RegisteredTournaments';
import RegisteredTournamentDetail from './RegisteredTournamentDetail';
 
export default TournamentsPage;
export { RegisteredTournaments, RegisteredTournamentDetail }; 